import styled from "styled-components";

export const Link = styled.div`
  display: flex;
  max-width: max-content;
`;
export const MyButton = styled.button`
 text-decoration: none;
  border: 2px solid #fff;
  border-radius: 3px;
  font-weight: bold;
  background-color: #32a600;
  color: white;
  padding: 0.5em;
  box-shadow: 0 2px 5px 0 rgba(0,0,0,.16),0 2px 10px 0 rgba(0,0,0,.12);
    
    ${Link}:hover & {
    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    box-shadow: 0 8px 11px 0 rgba(0,0,0,.16),0 2px 10px 0 rgba(0,0,0,.12);
    }
`;